const el = document.querySelector(".interactive");

const isTouchDevice = () => {
    // Covers iOS/Android ('ontouchstart' in window), touch-capable desktops (maxTouchPoints),
    // and other coarse-pointer environments.
    return (
        ('ontouchstart' in window) ||
        ((navigator.maxTouchPoints || 0) > 0) ||
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches)
    );
};

if (el) {
    if (isTouchDevice()) {
        // Prevent any parallax/translate behavior on touch devices.
        el.style.transform = 'none';
    } else {
        document.addEventListener('DOMContentLoaded', () => {    
            let curX = 0;
            let curY = 0;
            let tgX = 0;
            let tgY = 0;

            const move = () => {
                curX += (tgX - curX) / 20;
                curY += (tgY - curY) / 20;
                el.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
                requestAnimationFrame(move);
            };

            window.addEventListener('mousemove', (event) => {
                tgX = event.clientX;
                tgY = event.clientY;
            });

            move();
        });
    }
}
